import EmailIcon from '@mui/icons-material/Email';
import { Box, useTheme } from '@mui/material';
import React from 'react';

const MailIcon = ({ boxSize, iconSize }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: boxSize,
        height: boxSize,
        borderRadius: '50%',
        backgroundColor: theme.palette.icon.messages.background,
      }}
    >
      <EmailIcon
        sx={{
          color: theme.palette.icon.messages.contrast,
          fontSize: iconSize,
        }}
      />
    </Box>
  );
};

export default MailIcon;
